/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'fabric.linkPicker.button.cancel': 'Cancelar',
  'fabric.linkPicker.button.insert': 'Insertar',
  'fabric.linkPicker.button.save': 'Guardar',
  'fabric.linkPicker.clearLink': 'Borrar',
  'fabric.linkPicker.clearLinkText': 'Borrar texto',
  'fabric.linkPicker.hyperlink.searchLinkResults':
    '{count, plural, =0 {no hay resultados} one {{count,number} resultado encontrado} other {{count,number} resultado encontrado}}',
  'fabric.linkPicker.linkAriaLabel': 'Escribe o pega un enlace en el campo',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Enlace de texto auxiliar que se muestra',
  'fabric.linkPicker.linkHelperTextLabel': 'Ponle un título o una descripción a este enlace',
  'fabric.linkPicker.linkInvalid': 'Introduce una URL válida.',
  'fabric.linkPicker.linkLabel': 'Enlace',
  'fabric.linkPicker.linkPlaceholder': 'Pegar un enlace',
  'fabric.linkPicker.linkTextAriaLabel': 'Enlace de texto que se muestra',
  'fabric.linkPicker.linkTextLabel': 'Texto que se muestra (opcional)',
  'fabric.linkPicker.linkTextPlaceholder': 'Texto que se debe mostrar',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Historial reciente',
  'fabric.linkPicker.listTitle.results': 'Resultados',
  'fabric.linkPicker.noEmbed':
    'La vista incrustada no es compatible con este enlace. <a>Se puede encontrar más información sobre por qué algunos enlaces inteligentes no muestran contenido aquí.</a>',
  'fabric.linkPicker.search.error.description':
    'Actualiza la página o ponte en contacto con el <a>soporte de Atlassian</a> si sigue ocurriendo.',
  'fabric.linkPicker.search.error.heading': 'Tenemos problemas para cargar los datos.',
  'fabric.linkPicker.search.error.retry': 'Actualizar',
  'fabric.linkPicker.search.linkAriaLabel': 'Las sugerencias aparecerán abajo a medida que escribas en el campo',
  'fabric.linkPicker.search.linkLabel': 'Busca o pega un enlace',
  'fabric.linkPicker.search.linkPlaceholder': 'Busca enlaces recientes o pega un nuevo enlace',
  'fabric.linkPicker.search.noResults.description': 'Prueba con otro término.',
  'fabric.linkPicker.search.noResults.heading': 'No se ha podido encontrar nada que coincida con tu búsqueda.',
  'fabric.linkPicker.status.submitting': 'Enviando',
  'fabric.linkPicker.time.message.updated': 'Última actualización: {time}',
  'fabric.linkPicker.time.message.viewed': 'Visto: {time}',
  'fabric.linkPicker.unhandledError.description': 'Prueba volviendo a cargar la página.',
  'fabric.linkPicker.unhandledError.heading': 'Algo ha ido mal.',
};
